<template>
	<div id="calculator" @mousedown="downUp" v-show="isCalculatorShow">
		<!--显示框-->
		<span class="el-icon-close" @click="$parent.isCalculatorShow = false"></span>
		<input-box v-bind:input-show="inputShow"></input-box>
		<btn-list>
			<div @click="clearValue()" class=" btn-30 btn-radius color-red clear-marginleft">C</div>
			<div class=" btn-30 btn-radius color-blue">+/-</div>
			<div @click="inputValue('%')" class=" btn-30 btn-radius color-blue">%</div>
			<div @click="backValue()" class=" btn-70 btn-radius color-red font-14">←</div>
			<div @click="inputValue('7')" class=" btn-30 btn-radius clear-marginleft">7</div>
			<div @click="inputValue('8')" class=" btn-30 btn-radius">8</div>
			<div @click="inputValue('9')" class=" btn-30 btn-radius">9</div>
			<div @click="squareValue()" class=" btn-30 btn-radius color-blue font-14">×²</div>
			<div @click="radicalValue()" class=" btn-30 btn-radius color-blue font-12">√</div>
			<div @click="inputValue('4')" class=" btn-30 btn-radius clear-marginleft">4</div>
			<div @click="inputValue('5')" class=" btn-30 btn-radius">5</div>
			<div @click="inputValue('6')" class=" btn-30 btn-radius">6</div>
			<div @click="inputValue('×')" class=" btn-30 btn-radius color-blue font-14">×</div>
			<div @click="inputValue('÷')" class=" btn-30 btn-radius color-blue font-12">÷</div>
			<div @click="inputValue('1')" class=" btn-30 btn-radius clear-marginleft">1</div>
			<div @click="inputValue('2')" class=" btn-30 btn-radius">2</div>
			<div @click="inputValue('3')" class=" btn-30 btn-radius">3</div>
			<div @click="inputValue('+')" class=" btn-30 btn-radius color-blue font-14">+</div>
			<div @click="inputValue('-')" class=" btn-30 btn-radius color-blue font-14">-</div>
			<div @click="inputValue('0')" class=" btn-70 btn-radius clear-marginleft">0</div>
			<div @click="inputValue('.')" class=" btn-30 btn-radius">.</div>
			<div @click="calValue()" class=" btn-70 btn-radius color-red font-14">=</div>
		</btn-list>
	</div>
</template>
<script>
	export default {
		name: 'calculator',
		data() {
			return {
				inputShow: {
					value: '0'
				}
			}

		},
		props: {
			isCalculatorShow: [Boolean]

		},
		components: {
			'input-box': {
				props: ['inputShow'],
				computed: {
					value: function() {
						return this.inputShow.value
					}
				},
				template: '<input id="input-box" type="text" size="21" maxlength="21" v-model="value" readonly="readonly">'
			},
			'btn-list': {
				template: '<div id="btn-list"><slot></slot></div>'
			}
		},
		methods: {
			inputValue(param){
				if(Object.prototype.toString.call(this.inputShow.value) == "[object Number]"){   //判断输入框内容是否为数字类型
					this.inputShow.value = "0";   //数字类型说明是上个计算结果,清空内容
				}
				var str ='' + this.inputShow.value; //输入内容时,将输入框内容转为字符串类型
				var len = str.length;
				var arr = ["+","-","×","÷"];
				var num = (''+parseFloat(str.split('').reverse().join(''))).split('').reverse().join('');   //parseInt(str.split('').reverse().join('')))是获取输入框内最后一串数字,再反转回来 ,num为输入框内最后一串数字
				var nlen = num.length;
				if((num!= '0' && param != '.')|| (param == '.'&& num.indexOf(".")==-1)){   //输入框内最后一串数字不为0时拼接字符串
					if(arr.indexOf(str.charAt(len-1)) != -1 && arr.indexOf(param) != -1){    //若一开始输入内容为运算符,输入无效
						return;
					}
					this.inputShow.value += param;   //拼接输入内容
				}else{
					arr.push("%");
					if(param == '.'){      //若num中已有小数点,输入内容为小数点,视为无效
						return;
					}else if(!(arr.indexOf(param) != -1)){    //判断输入框内最后一个字符不为运算符
						this.inputShow.value =str.substring(0,str.length-nlen) + param;  //输入框内最后一串数字为0时,删除0拼接
					}
				}
			},
			clearValue(){      //清空输入框内容
				this.inputShow.value = '0';
			},
			calValue(){       //计算结果
				var str = this.inputShow.value;
				str = str.replace('×','*').replace('÷','/').replace('%','*0.01');    //替换运算符
				try{
					this.inputShow.value = eval(str);      //若用户输入内容不符合运算规则,不计算
				}catch(error){
					return;
				}
			},
			squareValue(){             //平方计算
				var str = this.inputShow.value;
				this.inputShow.value = Math.pow(eval(str),2)
			},
			radicalValue(){             //开根号计算
				var str = this.inputShow.value;
				this.inputShow.value = Math.sqrt(eval(str));
			},
			backValue(){              //删除键,删除单个字符
				var str = this.inputShow.value;
				if(str.length == 1){
					this.inputShow.value = "0";
				}else{
					 this.inputShow.value = str.slice(0,str.length-1);
				}
			},
			downUp(event) {
				window.onmousedown = new Function("return false");
				window.onmouseup = new Function("return true");
				let odiv = event.target; //获取目标元素
				//算出鼠标相对元素的位置
				let disX = event.clientX - odiv.offsetLeft;
				let disY = event.clientY - odiv.offsetTop;
				document.onmousemove = (event2) => {
					odiv.style.right = 'auto'; //鼠标按下并移动的事件
					//用鼠标的位置减去鼠标相对元素的位置，得到元素的位置

					let left = event2.clientX - disX;
					let top = event2.clientY - disY;
					//绑定元素位置到positionX和positionY上面
					this.positionX = top;
					this.positionY = left;
					//移动当前元素
					odiv.style.left = left + 'px';
					odiv.style.top = top - 30 + 'px';

				};
				document.onmouseup = () => {
					window.onmousedown = null
					window.onmouseup = null
					document.onmousemove = null;
					document.onmouseup = null;
				};
			}
		}
	}
</script>
<style scoped>
	#calculator {
		cursor: move;
		position: fixed;
		top: 56px;
		right: 24px;
		z-index: 1000;
		width: 200px;
		height: 285px;
		padding: 10px;
		border: 1px solid #e5e5e5;
		background: linear-gradient(90deg, rgba(83, 151, 247, 1) 0%, rgba(111, 146, 255, 1) 100%);
		-moz-border-radius: 3px;
		-webkit-border-radius: 3px;
		border-radius: 3px;
		box-shadow: 0px 0px 10px #ccc;
		-moz-box-shadow: 0px 0px 10px #ccc;
		-webkit-box-shadow: 0px 0px 10px #ccc;
		margin: 40px auto 0 auto;
	}

	#calculator #input-box {
		margin: 0;
		width: 187px;
		padding: 9px 5px;
		height: 14px;
		border: 1px solid #e5e5e5;
		border-radius: 3px;
		-webkit-border-radius: 3px;
		-moz-border-radius: 3px;
		background: #FFF;
		text-align: right;
		line-height: 14px;
		font-size: 12px;
		font-family: Verdana, Geneva, sans-serif;
		color: #666;
		outline: none;
		text-transform: uppercase;
	}

	#calculator #btn-list {
		width: 200px;
		overflow: hidden;
	}

	#calculator #btn-list .btn-radius {
		border-radius: 2px;
		-webkit-border-radius: 2px;
		-moz-border-radius: 2px;
		border: 1px solid #e5e5e5;
		background: -webkit-gradient(linear, 0 0, 0 100%, from(#f7f7f7), to(#ebebeb));
		background: -moz-linear-gradient(top, #f7f7f7, #ebebeb);
		filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#f7f7f7, endColorstr=#ebebeb, grandientType=1);
		line-height: 29px;
		text-align: center;
		text-shadow: 0px 1px 1px #FFF;
		font-weight: bold;
		font-family: Verdana, Geneva, sans-serif;
		color: #666;
		float: left;
		margin-left: 11px;
		margin-top: 11px;
		font-size: 12px;
		cursor: pointer;
	}

	#calculator #btn-list .btn-radius:active {
		background: #ffffff;
	}

	#calculator #btn-list .clear-marginleft {
		margin-left: 0;
	}

	#calculator #btn-list .font-14 {
		font-size: 14px;
	}

	#calculator #btn-list .color-red {
		color: #ff5050
	}

	#calculator #btn-list .color-blue {
		color: #00b4ff
	}

	#calculator #btn-list .btn-30 {
		width: 29px;
		height: 29px;
	}

	#calculator #btn-list .btn-70 {
		width: 70px;
		height: 29px;
	}


	#calculator #btn-list>* {
		background: #ffffff;
		-o-user-select: none;
		-moz-user-select: none;
		/*火狐 firefox*/
		-webkit-user-select: none;
		/*webkit浏览器*/
		-ms-user-select: none;
		/*IE10+*/
		-khtml-user-select: none;
		/*早期的浏览器*/
		user-select: none;
	}

	#calculator #btn-list>*:hover {
		background: rgba(245, 250, 255, .8);
	}

	#calculator #btn-list>*:active {
		opacity: .8;
	}

	#calculator>span {
		float: right;
		cursor: pointer;
		font-size: 14px;
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testSumulationComponentNew/calculator.vue